<template>
  <div class="AvisoCookies">
    <div class="aviso-cookies" id="aviso-cookies">
      <div class="d-flex">
        <img class="img-fluid galleta"
          src="https://firebasestorage.googleapis.com/v0/b/legal-by-sofu.appspot.com/o/recursos%2FAviso%20Cookies%2FIMAGEN-CABECERA-COOKIES.svg?alt=media&token=cb5e7ea3-5a13-44c5-bc32-95a2347444d6" />
        <div style="margin-top: -25px">
          <h3 class="titulo font-weight-bold">¡Cookies!</h3>
          <p class="parrafo">
            Quiero que sepas que estamos usando cookies propias y de terceros para conseguir una mejor experiencia
            de navegación, obtener información estadística e interactuar en redes sociales. Haciendo clic en
            <b>Aceptar</b> consientes las cookies en nuestro sitio. Puedes configurar o rechazar su uso en
            <b>Ajustes</b>. Tienes más información sobre este tema en nuestra <router-link class="enlace"
              to="/politicacookies">Politíca de Cookies
            </router-link>.
          </p>
          <button class="boton" id="btn-ajustes-cookies">Ajustes</button>
          <button class="boton2" id="btn-aceptar-cookies">Aceptar</button>
        </div>
      </div>
    </div>
    <!-- MODAL - CONFIGURACIÓN DE COOKIES -->
    <div class="modal fade fondo__Modal" id="configuracionCookies" role="dialog" aria-labelledby="configuracionCookies"
      data-backdrop="static" data-keyboard="false" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-scrollable" role="document">
        <div class="modal-content p-3 color__Modal borde__RedondoModal">
          <div class="modal-header">
            <h5 class="titulos font-weight-bold" style="margin-top: -5px;">
              ¡Cookies!
            </h5>
          </div>
          <div class="modal-header">
            <p class="parrafos">Elige qué tipo de cookies deseas aceptar.</p>
          </div>
          <div class="modal-header" style="margin-top: -20px;">
            <router-link class="enlaces" to="/politicacookies" data-dismiss="modal">Politíca de Cookies.</router-link>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 form-group">
                <div class="d-flex align-items-center">
                  <div class="mr-auto">
                    <h5 class="font-weight-bold">Necesarias</h5>
                    <p style="font-size: 12pt">Estas cookies no son opcionales. Son necesarias para que funcione la web
                      correctamente.</p>
                  </div>
                  <div class="togglebutton mt-5 ml-3">
                    <label class="parrafos">
                      <input type="checkbox" v-model="cookiesNecesarias" disabled />
                      <span class="toggle mr-2"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <div class="mr-auto">
                    <h5 class="font-weight-bold">Experiencia</h5>
                    <p style="font-size: 12pt">Para que nuestra web funcione lo mejor posible durante tu visita. Si
                      rechazas estas cookies, algunas funcionalidades no se mostrarán en la web.</p>
                  </div>
                  <div class="togglebutton mt-4 ml-3">
                    <label class="parrafos">
                      <input type="checkbox" v-model="cookiesExperiencia" />
                      <span class="toggle mr-2"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" id="btn-guardar-cookies-modal" class="btn btn-secondary">Guardar</button>
            <button type="button" id="btn-aceptar-cookies-modal" class="btn btn-primary">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="fondo-transparente" id="fondo-transparente"></div>
  </div>
</template>

<script>
export default {
  name: "AvisoCookies",

  data() {
    return {
      cookiesNecesarias: true,
      cookiesExperiencia: false,
    }
  },

  watch: {
    $route(to) {
      const avisoCookies = document.getElementById("aviso-cookies");
      const fondoAvisoCookies = document.getElementById("fondo-transparente");
      const container = document.body;
      if (to.path === "/politicacookies" || to.path === "/politicaprivacidad" ) {
        avisoCookies.classList.remove("activo");
        fondoAvisoCookies.classList.remove("activo");
        container.classList.remove("body-activo");
      } else {
        if (!localStorage.getItem("cookiesAceptadas")) {
          avisoCookies.classList.add("activo");
          fondoAvisoCookies.classList.add("activo");
          container.classList.add("body-activo");
        }
      }
    }
  },

  mounted() {
    this.$store.state.cerrarModal();
    this.detectarResolucion();
    this.ajustarResolucion();
    this.funcionesAviso();
    this.funcionesModal();
  },

  created() {
    let cookiesAceptadas = localStorage.getItem("cookiesAceptadas")
    if (cookiesAceptadas === 'true') {
      if (localStorage.getItem('cookiesExperiencia') === 'true') {
        this.cookiesExperiencia = true
      } else {
        this.cookiesExperiencia = false
      }
    } else {
      localStorage.removeItem("cookiesNecesarias");
      localStorage.removeItem("cookiesExperiencia");
      localStorage.removeItem('modoOscuro');
      localStorage.removeItem('filtroComunidad');
    }
  },

  methods: {
    ajustarResolucion() {
      $(window).resize(() => {
        if (window.matchMedia("screen and (max-width:767px)").matches) {
          $("#configuracionCookies").addClass("modal__PantallaCompleta");
        } else {
          $("#configuracionCookies").removeClass("modal__PantallaCompleta");
        }
      });
    },

    detectarResolucion() {
      if (window.matchMedia("screen and (max-width:767px)").matches) {
        $("#configuracionCookies").addClass("modal__PantallaCompleta");
      } else {
        $("#configuracionCookies").removeClass("modal__PantallaCompleta");
      }
    },

    funcionesAviso() {
      const botonAjustesCookes = document.getElementById("btn-ajustes-cookies");
      const botonAceptarCookies = document.getElementById("btn-aceptar-cookies");
      const avisoCookies = document.getElementById("aviso-cookies");
      const fondoAvisoCookies = document.getElementById("fondo-transparente");
      const container = document.body;

      // CLICK PARA ACEPTAR COOKIES Y DESACTIVAR ESTILOS
      botonAceptarCookies.addEventListener("click", () => {
        avisoCookies.classList.remove("activo");
        fondoAvisoCookies.classList.remove("activo");
        container.classList.remove("body-activo");
        localStorage.setItem("cookiesAceptadas", true);
        localStorage.setItem("cookiesNecesarias", true);
        localStorage.setItem("cookiesExperiencia", true);
      });

      // CLICK PARA CONFIGURAR COOKIES
      botonAjustesCookes.addEventListener("click", () => {
        avisoCookies.classList.remove("activo");
        fondoAvisoCookies.classList.remove("activo");
        container.classList.remove("body-activo");
        $('#configuracionCookies').modal('show')
      });
    },

    funcionesModal() {
      const botonGuardarCookies = document.getElementById("btn-guardar-cookies-modal");
      const botonAceptarCookies = document.getElementById("btn-aceptar-cookies-modal");
      const avisoCookies = document.getElementById("aviso-cookies");
      const fondoAvisoCookies = document.getElementById("fondo-transparente");
      const container = document.body;

      // CLICK PARA GUARDAR COOKIES Y DESACTIVAR ESTILOS
      botonGuardarCookies.addEventListener("click", () => {
        avisoCookies.classList.remove("activo");
        fondoAvisoCookies.classList.remove("activo");
        container.classList.remove("body-activo");
        if (!localStorage.getItem('cookiesAceptadas')) {
          localStorage.setItem("cookiesAceptadas", true);
        }
        localStorage.setItem("cookiesNecesarias", this.cookiesNecesarias);
        localStorage.setItem("cookiesExperiencia", this.cookiesExperiencia);
        if (localStorage.getItem('cookiesExperiencia') === 'false') {
          localStorage.setItem('modoOscuro', false);
          document.body.classList.remove("dark");
          localStorage.removeItem('modoOscuro');
          localStorage.removeItem('filtroComunidad');
        }
        $('#configuracionCookies').modal('hide');
      });

      // CLICK PARA ACEPTAR COOKIES Y DESACTIVAR ESTILOS
      botonAceptarCookies.addEventListener("click", () => {
        avisoCookies.classList.remove("activo");
        fondoAvisoCookies.classList.remove("activo");
        container.classList.remove("body-activo");
        this.cookiesExperiencia = true;
        if (!localStorage.getItem('cookiesAceptadas')) {
          localStorage.setItem("cookiesAceptadas", true);
        }
        localStorage.setItem("cookiesNecesarias", true);
        localStorage.setItem("cookiesExperiencia", true);
        $('#configuracionCookies').modal('hide');
      });
    },
  }
};
</script>

<style>
.body-activo {
  overflow-y: hidden;
  height: 100vh;
  pointer-events: none;
}

.body-activo .footer {
  z-index: 98;
}

.alerta {
  pointer-events: all;
}

.aviso-cookies {
  display: none;
  background: rgb(230, 231, 232);
  padding: 20px;
  width: 100%;
  max-width: 100%;
  line-height: 150%;
  position: absolute;
  bottom: 0px;
  z-index: 100;
  padding-top: 60px;
  text-align: justify;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.activo {
  display: block;
}

.aviso-cookies .galleta {
  margin-top: -120px;
  width: 350px;
  max-width: 400px;
}

.aviso-cookies .titulo,
.aviso-cookies .parrafo {
  margin-bottom: 15px;
  font-size: 17pt
}

.aviso-cookies .boton {
  background: transparent;
  border: none;
  color: #222;
  font-family: "Roboto", sans-serif;
  text-align: center;
  padding: 15px 20px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s ease all;
  border-radius: 5px;
  margin-bottom: 15px;
  font-size: 14px;
  pointer-events: all;
}

.aviso-cookies .boton2 {
  background: #3c3c44;
  border: none;
  color: #fff;
  font-family: "Roboto", sans-serif;
  text-align: center;
  padding: 15px 20px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s ease all;
  border-radius: 5px;
  margin-bottom: 0px;
  font-size: 14px;
  pointer-events: all;
}

.aviso-cookies .boton:hover {
  color: gray;
}

.aviso-cookies .boton2:hover {
  background: #fff;
  color: #6127ff;
}

.aviso-cookies .enlace {
  color: #6127ff;
  text-decoration: none;
  font-size: 15pt;
  pointer-events: all;
  text-decoration: underline;
}

.fondo-transparente {
  display: none;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
}

.fondo-transparente.activo {
  display: block;
}

@media screen and (max-width: 1000px) {

  .aviso-cookies .boton,
  .aviso-cookies .boton2 {
    width: 50%;
  }

  .aviso-cookies .titulo {
    text-align: center;
  }

  .aviso-cookies .galleta {
    max-width: 200px;
    position: absolute;
    top: -18px;
    left: calc(50% - 100px);
  }

  .aviso-cookies .enlace,
  .aviso-cookies .parrafo {
    font-size: 13pt
  }
}

@media screen and (max-width: 767px) {
  .aviso-cookies {
    position: absolute;
    max-width: 110%;
  }

  .aviso-cookies .boton,
  .aviso-cookies .boton2 {
    width: 100%;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .aviso-cookies .galleta {
    max-width: 150px;
    position: absolute;
    top: 30px;
    left: calc(50% - 70px);
  }
}

@media only screen and (min-device-width: 280px) and (max-device-width: 280px) {
  .aviso-cookies .galleta {
    max-width: 150px;
    position: absolute;
    top: 30px;
    left: calc(50% - 70px);
  }

  .aviso-cookies .titulo,
  .aviso-cookies .enlace,
  .aviso-cookies .parrafo {
    font-size: 11pt
  }
}

body.dark .aviso-cookies {
  background-color: rgb(41, 40, 42);
  color: white;
}

body.dark .boton {
  color: white
}
</style>

<style scoped>
/* TEMA CLARO */
div {
  animation: none;
}

.fondo__Modal {
  background: rgba(47, 47, 47, 0.5);
}

.color__Modal {
  background-color: #fff;
  color: #34343c;
  box-shadow: none;
}

.borde__RedondoModal {
  border-radius: 10px;
}

.enlaces {
  color: #6127ff;
  text-decoration: none;
  font-size: 15pt;
  pointer-events: all;
  text-decoration: underline;
}

.titulos,
.parrafos {
  font-family: "Roboto", sans-serif;
  margin-bottom: 15px;
  font-size: 15pt
}

.btn-primary,
.btn-secondary {
  font-family: "Roboto", sans-serif;
  text-transform: none;
  font-size: 14px;
}

.btn-secondary {
  background: transparent;
  color: #34343c
}

.btn-primary {
  background: #3c3c44;
  box-shadow: none;
}

.btn-secondary,
.btn-secondary:hover {
  box-shadow: none;
  background: transparent;
}

.btn-primary:hover,
.btn-primary:active,
.btn-primary:focus {
  background: #f3f3f3;
  color: #6127ff;
  box-shadow: none;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled):hover,
.btn-primary:not(:disabled):not(.disabled).hover {
  color: #6127ff;
  background-color: #f3f3f3;
  border-color: none;
}

.togglebutton label input[type="checkbox"]:checked+.toggle {
  background-color: #3c3c44;
}

.togglebutton label input[type='checkbox']:checked+.toggle:after {
  border-color: #3c3c44;
}

.modal.modal__PantallaCompleta .modal-dialog {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  max-width: none;
}

.modal.modal__PantallaCompleta .modal-content {
  height: auto;
  height: 100vh;
  border-radius: 0;
  border: none;
}

.modal.modal__PantallaCompleta .modal-body {
  overflow-y: auto;
}

@media screen and (max-width: 1000px) {
  .parrafos {
    font-size: 13pt
  }
}

/* TEMA OSCURO */
body.dark .color__Modal {
  background-color: rgb(41, 40, 42);
  color: white;
}

body.dark .togglebutton label input[type="checkbox"]:checked+.toggle {
  background-color: gray;
}

body.dark .togglebutton label input[type='checkbox']:checked+.toggle:after {
  border-color: gray;
}

body.dark .btn-secondary {
  color: white
}
</style>